import i18next from '../i18n';
import { handleErrorToast, handleWarningToast } from 'src/components/molecules';

export const handleUpdatePasswordErrors = (err: string) => {
  if (err === 'Password has been used before') {
    handleWarningToast({
      toastMessage: i18next.t(
        'reporting.ReportingForgotPassword.passwordReuseError',
      ),
      toastDescription: i18next.t(
        'reporting.ReportingForgotPassword.passwordReuseErrorDescription',
      ),
    });
  } else if (err === 'Account is frozen') {
    handleErrorToast({
      toastMessage: i18next.t('reporting.ReportingLogin.accountFrozen'),
      toastDescription: i18next.t('reporting.ReportingLogin.accountLocked'),
    });
  } else if (err === 'Invalid or missing token') {
    handleErrorToast({
      toastMessage: i18next.t(
        'reporting.ReportingForgotPassword.invalidTokenError',
      ),
    });
  } else {
    handleErrorToast({
      toastMessage: err,
    });
  }
};
